import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkFlatButton } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';

const ButtonTracked = ClickTracker(UitkFlatButton);

export const MyList: React.FunctionComponent = () => (
  <div className="my-list">
    <ButtonTracked id="my-list-button" rfrr="PWA.Header.MyList" href="/lists" linkName="My List" data-stid="my-list-button">
      <UitkIcon name="favorite" className="my-list__icon" />
      <span className="is-visually-hidden">My List</span>
    </ButtonTracked>
  </div>
);
MyList.displayName = 'MyList';
